import { Directive } from '../../../types';

import {
  IngressClassPayload,
  KubernetesSetupFormData,
  KubernetesSetupPolicyPayload,
  StorageClassPayload,
} from './types';

/**
 * Builds the API payload from form data
 * Wraps values in Directive structure as expected by backend
 */
export function buildKubernetesSetupPayload(
  formData: KubernetesSetupFormData
): KubernetesSetupPolicyPayload {
  // Handle ingressControllers - can be array of objects or undefined
  // Map to Array<Directive<IngressClassPayload>> objects with PascalCase keys for backend
  // Note: enforce is set to true because when a user adds an ingress controller to a policy,
  // they intend for it to be applied/enforced on the target environments
  const ingressControllers: Array<Directive<IngressClassPayload>> =
    Array.isArray(formData.ingressControllers)
      ? formData.ingressControllers
          .filter((ic) => ic.name && ic.name.trim())
          .map((ic) => ({
            value: {
              Name: ic.name,
              Type: 'custom',
              GloballyBlocked: false,
              BlockedNamespaces: [],
            },
            enforce: true,
          }))
      : [];

  // Handle storageClasses - can be array of objects or undefined
  // Backend expects an array of Directives, each wrapping a StorageClassPayload object with PascalCase keys
  // Note: enforce is set to true because when a user adds a storage class to a policy,
  // they intend for it to be applied/enforced on the target environments
  const storageClasses: Array<Directive<StorageClassPayload>> = Array.isArray(
    formData.storageClasses
  )
    ? formData.storageClasses
        .filter((sc) => sc.name && sc.name.trim())
        .map((sc) => ({
          value: {
            Name: sc.name,
            AccessModes: sc.accessModes || [],
            AllowVolumeExpansion: sc.allowVolumeExpansion,
          },
          enforce: true,
        }))
    : [];

  return {
    UseLoadBalancer: {
      value: formData.useLoadBalancer,
      enforce: false,
    },
    UseServerMetrics: {
      value: formData.useServerMetrics,
      enforce: false,
    },
    EnableResourceOverCommit: {
      value: formData.enableResourceOverCommit,
      enforce: false,
    },
    ResourceOverCommitPercentage: {
      value: formData.resourceOverCommitPercentage,
      enforce: false,
    },
    IngressAvailabilityPerNamespace: {
      value: formData.ingressAvailabilityPerNamespace,
      enforce: false,
    },
    AllowNoneIngressClass: {
      value: formData.allowNoneIngressClass,
      enforce: false,
    },
    StorageClasses: storageClasses,
    IngressClasses: ingressControllers,
    RestrictStandardUserIngressW: {
      value: formData.restrictStandardUserIngressW,
      enforce: false,
    },
    // TODO: not setup yet
    DeploymentOptions: {
      value: {},
      enforce: false,
    },
    EndpointChangeWindow: {
      value: formData.changeWindow,
      enforce: false,
    },
  };
}
